const COLORS = {
  accent: '#4F77DE',
  accentLight: '#FAFBFE',
  textColor: '#202224',
  textSecondColor: '#778097',
  textColorLight: '#7B8898',
  gray: '#E9EAEC',
  orange: '#FF8F63',
  borderColor: '#C3CFD8',
  pink: '#EE86FF',
  red: '#FF0000',
  green: '#00B69B',
  white: '#FFFFFF'
};

export default COLORS;
